import React from 'react';
import { fetchParkingSpots } from '../../helpers/poiHelper';
import debounce from 'lodash.debounce';
import { observer } from 'mobx-react-lite';

export const Parking = observer(({ config, parking, map }) => {
  return config.features.parking ? (
    <div
      className="bg-white w-12 h-12 ml-2 cursor-pointer relative flex items-center justify-center text-parking text-xl rounded-full shadow-md transition-all"
      onClick={debounce(() => {
        if (parking?.parkopedia?.parkingSpots?.data?.length) {
          parking.parkopedia.setStoreEmpty();
        } else {
          const { lng, lat } = map.current._map.getCenter();
          fetchParkingSpots(parking, config, lat, lng);
        }
      }, config.gysService.debounceDelay)}
    >
      { parking?.parkopedia?.parkingSpots?.data?.length ? (
        <span className="bg-success w-5 h-5 flex justify-center items-center text-white rounded-full shadow absolute -bottom-1 right-0">
          <span className="text-[8px] icon icon-check"></span>
        </span>
      ) : null }
      <span className="icon icon-parking text-2xl" />
    </div>
  ) : null;
});
